import axios from 'axios'

export default {
  state: {
    usuarios: [],
  },
  mutations: {
    setUsuarios(state, payload) {
      state.usuarios = payload
    },
  },
  actions: {
    setUsuarios(context, payload) {
      context.commit('setUsuarios', payload)
    },
    loadUsuarios(context) {
      axios('user').then((resp) => {
        resp.data.forEach((element) => {
          element.text = `${element.id} - ${element.name}`
          element.value = element.id
          element.ativo = element.enabled ? 'SIM' : 'NÃO'
        })
        context.commit('setUsuarios', resp.data)
      })
    },
    // editUser(context, payload) {
    //   axios.put(`user/${payload.id}`, payload).then((resp) => {
    //     if (resp.status < 400) {
    //       context.dispatch("resetSnack");
    //       context.dispatch("showSuccessSnack", "Usuário salvo com Sucesso");
    //     }
    //   })
    // },
    saveUser(context, payload) {
      const metodo = payload.id ? "put" : "post";
      const finalUrl = payload.id ? `/${payload.id}` : "";
      axios[metodo](`/user${finalUrl}`, payload).then((resp) => {
          if(resp.status < 399){
              context.dispatch("resetSnack");
              context.dispatch("showSuccessSnack", "Usuário salvo com Sucesso");
              context.dispatch("loadUsuarios");
          }
      });
  },
  },
  getters: {
    getUsuarios(state) {
      return state.usuarios
    },
    getUsuarioById: (state) => (id) => {
      return state.usuarios.find((usuario) => usuario.id === id)
    },
  },
}